import { Injectable, Input } from "@angular/core";
import { CanLoad, Router } from "@angular/router";
import { Observable } from "rxjs";
import { filter, map, take } from "rxjs/operators";
import { ApiService } from "./../services/api.service";

@Injectable({
  providedIn: "root",
})
export class AutoLoginGuard implements CanLoad {
  @Input() menu: string;
  constructor(private authService: ApiService, private router: Router) {}

  canLoad(): Observable<boolean> {
    return this.authService.isAuthenticated.pipe(
      filter((val) => val !== null), // Filter out initial Behaviour subject value
      take(1), // Otherwise the Observable doesn't complete!
      map((isAuthenticated) => {
        if (isAuthenticated.authenticated) {
          // Directly open inside area

          this.router.navigateByUrl("/home", { replaceUrl: true });
        } else {
          // Simply allow access to the login

          return true;
        }
      })
    );
  }
}
